// removed by extract-text-webpack-plugin
module.exports = {"searchResult":"searchResult--2wEGI","title":"title--30QdS","description":"description--3FWUv"};